import { useState } from 'react';

const biCustomerModel = () => {
  const intitalState = {
    id: 0,
    account: '',
    accountName: '',
    createdDate: '',
    firstCreatedDate: '',
    rep: '',
    isNewAccount: true,
    isNewCreatedDateCycle: true,
    industrySub: '',
    businessCode: '',
  };

  const [biCustomer, setBiCustomer] = useState(intitalState);

  return { biCustomer, setBiCustomer, intitalState };
};

export default biCustomerModel;
